<template>
  <v-container fluid pa-0 v-if="innerValue && innerValue.length > 0">
    <v-row align="center" justify="center">
      <v-col class="px-0" cols="12">
        <v-card class="pa-3" color="rgba(255,255,255,0.2)">
          <v-form ref="listForm" v-model="listFormIsValid">
            <template v-if="type === 'field'">
              <v-row :key="index"
                     justify="center"
                     no-gutters
                     v-for="(item, index) in innerValue"
              >
                <div :class="{ 'mb-3': index+1 < innerValue.length }"
                     class="mr-3"
                     style="width: 25px;"
                >
                  <v-row align="center" class="fill-height" justify="center" no-gutters>
                    {{ $t_num(index+1) }}:
                  </v-row>
                </div>
                <v-text-field ref="text_field"
                              :class="{ 'mb-3': index+1 < innerValue.length }"
                              :rules="rules"
                              :value="item"
                              @input="emitInner($event, index)"
                              autocomplete="off"
                              background-color="white"
                              @paste.prevent
                              hide-details
                              :label="$t('general.type_answer_here')"
                              light
                              outlined
                              single-line
                >
                  <template v-if="index+1 > min" v-slot:append>
                    <v-btn @click="removeListItem(index)" icon small>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-row>
            </template>
            <template v-if="type === 'area'">
              <v-row :key="index"
                     justify="center"
                     no-gutters
                     v-for="(item, index) in innerValue"
              >
                <div :class="{ 'mb-3': index+1 < innerValue.length }"
                     class="mr-3 mt-1"
                     style="width: 25px;"
                >
                  <v-row align="start" class="fill-height" justify="center" no-gutters>
                    {{ index+1 }}:
                  </v-row>
                </div>
                <v-textarea ref="text_area"
                            :class="{ 'mb-3': index+1 < innerValue.length }"
                            :rules="rules"
                            :value="item"
                            @input="emitInner($event, index)"
                            autocomplete="off"
                            background-color="white"
                            class="elevation-1"
                            @paste.prevent
                            hide-details
                            :label="$t('general.type_answer_here')"
                            light
                            no-resize
                            outlined
                            rows="4"
                            single-line
                >
                  <template v-if="index+1 > min" v-slot:append>
                    <v-btn @click="removeListItem(index)" icon small>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-textarea>
              </v-row>
            </template>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="space-between">
      <v-btn :disabled="(max && (max <= innerValue.length))"
             @click="addListItem()"
             text
      >
        <v-icon>
          mdi-plus-circle-outline
        </v-icon>
        {{$t('general.add')}}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "TextList",
        props: {
            value: {
                required: true,
                type: Array
            },
            type: {
                type: String,
                default: 'field'
            },
            min: {
                type: Number,
                default: 1
            },
            max: {
                type: Number,
                default: null
            }
        },
        data: () => ({
            innerValue: null,
            listFormIsValid: false,
            rules: [v => !!v || 'This field is required'],
            fieldFocus: 0,
        }),
        methods: {
            cloneInner() {
                this.innerValue = JSON.parse(JSON.stringify(this.value));
                if (this.min > this.innerValue.length) {
                    for (let i = 0; i < this.min; i++) {
                        if (!this.innerValue[i]) {
                            this.innerValue.push('');
                        }
                    }
                }
            },
            emitInner(event, index) {
                this.innerValue[index] = event;
                this.emitValue();
            },
            emitValue(){
              if ((JSON.stringify(this.innerValue) !== JSON.stringify(this.value))) {
                this.$emit('input', this.innerValue);
              }
            },
            addListItem() {
              this.innerValue.push('');
                setTimeout(() => {
                    if(this.$refs['text_field']) {
                        this.$refs['text_field'][(this.innerValue.length - 1)].focus();
                    } else {
                        this.$refs['text_area'][(this.innerValue.length - 1)].focus();
                    }
                }, 100);
            },
            removeListItem(index) {
              this.$delete(this.innerValue, index);
              this.emitValue();
            },
            goToNext() {
                if (this.$refs.listForm.validate()) {
                    this.$emit('next');
                }
            }
        },
        mounted() {
            this.cloneInner();
            setTimeout(() => {
                if(this.$refs['text_field']) {
                    this.$refs['text_field'][0].focus();
                } else {
                    this.$refs['text_area'][0].focus();
                }
            }, 300);
            this.$watch('value',()=>{
              this.cloneInner();
            },{deep:true});
        }
    }
</script>

<style scoped>

</style>